var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 9.33342C8.35346 9.33342 8.6926 9.19294 8.94265 8.94289C9.19269 8.69284 9.33317 8.3537 9.33317 8.00008C9.33317 7.64646 9.19269 7.30732 8.94265 7.05727C8.6926 6.80722 8.35346 6.66675 7.99984 6.66675C7.64622 6.66675 7.30708 6.80722 7.05703 7.05727C6.80698 7.30732 6.6665 7.64646 6.6665 8.00008C6.6665 8.3537 6.80698 8.69284 7.05703 8.94289C7.30708 9.19294 7.64622 9.33342 7.99984 9.33342Z",
    fill: "#393E49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 9.33342C4.35346 9.33342 4.6926 9.19294 4.94265 8.94289C5.1927 8.69284 5.33317 8.3537 5.33317 8.00008C5.33317 7.64646 5.1927 7.30732 4.94265 7.05727C4.6926 6.80722 4.35346 6.66675 3.99984 6.66675C3.64622 6.66675 3.30708 6.80722 3.05703 7.05727C2.80698 7.30732 2.6665 7.64646 2.6665 8.00008C2.6665 8.3537 2.80698 8.69284 3.05703 8.94289C3.30708 9.19294 3.64622 9.33342 3.99984 9.33342Z",
    fill: "#393E49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 9.33342C12.3535 9.33342 12.6926 9.19294 12.9426 8.94289C13.1927 8.69284 13.3332 8.3537 13.3332 8.00008C13.3332 7.64646 13.1927 7.30732 12.9426 7.05727C12.6926 6.80722 12.3535 6.66675 11.9998 6.66675C11.6462 6.66675 11.3071 6.80722 11.057 7.05727C10.807 7.30732 10.6665 7.64646 10.6665 8.00008C10.6665 8.3537 10.807 8.69284 11.057 8.94289C11.3071 9.19294 11.6462 9.33342 11.9998 9.33342Z",
    fill: "#393E49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActions);
export default __webpack_public_path__ + "static/media/icon-actions.cb94cd88c98c3115cc52bbf59b6346e6.svg";
export { ForwardRef as ReactComponent };